import styled from 'styled-components'
import { IndexLayoutOldTitle } from '@sketch/modules-common'

import { breakpoint } from '@sketch/global-styles'

export const DetailsBreadcrumbsContainer = styled.div`
  display: none;

  ${breakpoint('sm')`
    display: block;

    text-align: center;
    margin-top: 12px;

    + ${IndexLayoutOldTitle} {
      margin-top: 32px;
    }
  `}
`
export const PaymentBreadcrumbsContainer = styled(DetailsBreadcrumbsContainer)`
  display: none;

  ${breakpoint('sm')`
    display: block;
    text-align: center;
    margin-top: -50px;
  `}
`
